import RecapProductList from 'components/Content/Recap/RecapProductList/RecapProductList.f';

export default RecapProductList;
